module.exports = __webpack_public_path__ + "static/media/testimonial_alan.b86f4fc7.png";